// this is an autogenerated file from App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/App/Connection/Status/Active/Settings/Content/IteroPreferencesAction/Content/ITeroPreferencesModal/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_AdminContent_SettingsContent_IntegrationsApplications_Content_App_Connection_Status_Active_Settings_Content_IteroPreferencesAction_Content_ITeroPreferencesModal_Content($parent_company_id: uuid!) {
  apps_external_mappings(
    where: {
      resource_schema: { _eq: "vaxiom" }
      resource_table: { _eq: "sys_organizations" }
      resource_id: { _eq: $parent_company_id }
    }
  ) {
    id
    metadata
  }
}

`